import { createFileRoute } from "@tanstack/react-router";
import { usageQueryOptions } from "@/app/billing/api/get-usage";
import { Dashboard } from "@/app/dashboard/dashboard";
import { oauthProvidersQueryOptions } from "@/app/oauth/api/get-o-auth-providers";
import { secretsQueryOptions } from "@/app/secrets/api/get-secrets";
import { serversQueryOptions } from "@/app/servers/api/get-servers";
import { toolkitCollectionQueryOptions } from "@/app/tools/api/get-toolkit-collection";
import { toolsQueryOptions } from "@/app/tools/api/get-tools";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/home"
)({
  component: Dashboard,
  beforeLoad(ctx) {
    const { queryClient } = ctx.context;
    const { organizationId } = ctx.params;

    queryClient.prefetchQuery(
      toolsQueryOptions({ binding: "project", scope: ctx.params })
    );
    queryClient.prefetchQuery(toolkitCollectionQueryOptions(ctx.params));
    queryClient.prefetchQuery(
      oauthProvidersQueryOptions({ binding: "project", scope: ctx.params })
    );
    queryClient.prefetchQuery(
      serversQueryOptions({ binding: "project", scope: ctx.params })
    );
    queryClient.prefetchQuery(
      secretsQueryOptions({ binding: "project", scope: ctx.params })
    );
    queryClient.prefetchQuery(usageQueryOptions({ organizationId }));
  },
  loader: () => ({
    crumb: "Dashboard",
  }),
});
